import { render, staticRenderFns } from "./ModalRecetas.vue?vue&type=template&id=3694a014&scoped=true&"
import script from "./ModalRecetas.vue?vue&type=script&lang=js&"
export * from "./ModalRecetas.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecetas.vue?vue&type=style&index=0&id=3694a014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694a014",
  null
  
)

export default component.exports